import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface OrderItemQuantityFieldProps {
  itemId: string;
  label: string;
  ariaLabel: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}

export const OrderItemQuantityField: React.FC<OrderItemQuantityFieldProps> = ({
  itemId,
  label,
  ariaLabel,
  value,
  onChange,
  onBlur,
}) => {
  const inputId = `item-quantity-${itemId}`;

  return (
    <div className="flex min-w-[6.75rem] items-center gap-2">
      <label
        htmlFor={inputId}
        className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground"
      >
        {label}
      </label>
      <div className="relative w-[4.5rem] shrink-0">
        <Input
          id={inputId}
          type="text"
          inputMode="numeric"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          className="h-8 w-full pr-7 text-right"
          aria-label={ariaLabel}
        />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className="absolute right-0 top-0 inline-flex h-8 w-7 items-center justify-center text-muted-foreground"
              aria-label={ariaLabel}
            >
              <ChevronDown className="h-4 w-4" aria-hidden />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" sideOffset={4} className="w-[4.5rem] min-w-0 p-1">
            {Array.from({ length: 9 }, (_, qtyIndex) => qtyIndex + 1).map((qty) => (
              <DropdownMenuItem
                key={qty}
                className="justify-center px-2"
                onSelect={() => {
                  onChange(qty.toString());
                  onBlur();
                }}
              >
                {qty}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
